<template>
    <v-card width="620" class="mx-auto" :loading="loading" :disabled="loading">
      <v-card-title>
        ข้อมูลจำนวนนักศึกษาที่นับถือศาสนาอิสลามทั้งหมด
      </v-card-title>
      <v-card-text>
        <v-btn color="green darken-3" class="white--text" @click="download()">
          ดาวน์โหลด<v-icon> mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
  </template>
  
  <script>
  import ReportProvider from "@/services/report.provider.js";
  const ReportService = new ReportProvider();
  import { studentStudy } from "./generate.js";
  
  export default {
    name: "ReportStudentIslam",
  
    data: () => ({
      loading: false,
    }),
  
    methods: {
      studentStudy,
  
      async download() {
        this.loading = true;
        const data = await ReportService.getReportStudentIslam(
        ).catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
     
        if (data['total'] == 0) {
          this.$toasted.error('ไม่พบข้อมูลนักศึกษา', {
            duration: 3000,
          });
        } else {
          studentStudy(data['res'], 'islam');
          this.$toasted.success('ดาวน์โหลดข้อมูลนักศึกษาเรียบร้อยแล้ว', {
            duration: 3000,
          });
        }
        this.loading = false;
      },
    },
  
  };
  </script>
  